import { render, staticRenderFns } from "./VeJwChengjiXsList.vue?vue&type=template&id=d8122e68&scoped=true"
import script from "./VeJwChengjiXsList.vue?vue&type=script&lang=js"
export * from "./VeJwChengjiXsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8122e68",
  null
  
)

export default component.exports